import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { axios, APIBASE_REVIVERTASKS } from "./ApiConfig";
import { Task, TaskType } from "@/types";
import { AxiosResponse } from "axios";

export const getOpenTasks = async (companyId: number): Promise<AxiosResponse<Task[]>> =>
  axios.get(`${APIBASE_REVIVERTASKS}api/tasks/open/${companyId}`);

export const useGetOpenTasks = (companyId: number, taskType?: TaskType, options?: Partial<UseQueryOptions<Task[]>>) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<Task[]>({
    queryKey: ["getOpenTasks", companyId],
    queryFn: async () => {
      const result = await getOpenTasks(companyId);
      if (taskType) {
        return result.data.filter((task) => task.type === taskType);
      }
      return result.data;
    },
    ...queryOptions,
  });
};

export const getOverdueTasks = async (companyId: number): Promise<AxiosResponse<Task[]>> =>
  axios.get(`${APIBASE_REVIVERTASKS}api/tasks/overdue/${companyId}`);

export const useGetOverdueTasks = (companyId: number, options?: any) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<Task[]>({
    queryKey: ["getOverdueTasks", companyId],
    queryFn: async () => {
      const result = await getOverdueTasks(companyId);
      return result.data;
    },
    ...queryOptions,
  });
};
